import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getDefaultRoute } from '../utils/getDefaultRoute';
import { EscolaPermissaoGuard } from './EscolaPermissaoGuard';
import { Loading } from './ui/loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireEscolaPermissao?: boolean;
}

export function ProtectedRoute({ 
  children, 
  requireAuth = true, 
  requireEscolaPermissao = true 
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading size="lg" message="Verificando autenticação..." />
      </div>
    );
  }

  // Se a rota requer autenticação e o usuário não está logado
  if (requireAuth && !isAuthenticated) {
    // Redirecionar para login, salvando a rota atual
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se a rota é pública (como login) e o usuário está logado
  if (!requireAuth && isAuthenticated) {
    // Redirecionar para rota padrão baseada no role
    const defaultRoute = getDefaultRoute(user);
    return <Navigate to={defaultRoute} replace />;
  }

  // Se requer escola e permissão, usar o guard
  if (requireAuth && requireEscolaPermissao) {
    return <EscolaPermissaoGuard>{children}</EscolaPermissaoGuard>;
  }

  // Renderizar o conteúdo da rota
  return <>{children}</>;
}
